<template>
    <div></div>
</template>

<script>
import { loginByToken } from '@/api/common/user.js';
import { postSwitchLanguage } from '@/components/lang/api/lang';
import { setLocalStorage } from '@/utils/tools/utils';

export default {
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const token = this.$route.query.token;
      if (token) {
        console.log('guantoken', token);
        // 通过 token 获取登录态&用户信息
        const loading = this.$loading();
        try {
          const res = await loginByToken({ token });
          const lang = this.$store.getters.app.currentLan;
          const language = lang === 'zh-cn' ? 'zh' : lang;
          await postSwitchLanguage(language);
          setLocalStorage('userLogin', JSON.stringify(res));
          setLocalStorage('BusinessTypes', JSON.stringify(res));
          await this.$store.dispatch('app/setUserLogin', res);
          await this.$store.dispatch('app/setBusinessTypes', res);

          this.$router.replace({ path: '/' });
          loading.close();
          return;
        } catch (err) {
          //
        }
        loading.close();
      }
      this.$router.replace({ path: '/user/login' });
    },
  },
};
</script>

<style>

</style>
